let currentVideoStream: MediaStream | null = null;

export function setVideoStream(stream: MediaStream | null) {
  currentVideoStream = stream;
}

export function getVideoStream(): MediaStream | null {
  return currentVideoStream;
}

const ROTATION_STORAGE_KEY = 'camera-video-rotation-deg';

const videoWindowTemplate = `<!DOCTYPE html>
<html>
<head>
  <title>视频通话</title>
  <style>
    * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
    }
    html, body {
      width: 100%;
      height: 100%;
      overflow: hidden;
      background-color: #000;
    }
    .video-wrapper {
      width: 100%;
      height: 100%;
    }
    .video-container {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      background-color: #000;
      cursor: pointer;
      position: relative;
    }
    #local-player {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
    }
    #local-player video {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transform: scaleX(-1);
      transform-origin: center center;
    }
    .no-video {
      color: #888;
      font-size: 16px;
      text-align: center;
    }
    .rotation-hint {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 12;
      min-width: 64px;
      padding: 8px 14px;
      border-radius: 999px;
      background: rgba(15, 23, 42, 0.72);
      color: #fff;
      font-size: 16px;
      font-weight: 600;
      letter-spacing: 0.04em;
      text-align: center;
      pointer-events: none;
      opacity: 0;
      transition: opacity 0.15s ease;
    }
    .rotation-hint.show {
      opacity: 1;
    }
  </style>
</head>
<body>
  <div class="video-wrapper" id="video-wrapper">
    <div class="video-container" id="video-container" title="点击调整画面方向">
      <div id="local-player">
        <p class="no-video">正在加载视频...</p>
      </div>
      <div class="rotation-hint" id="rotation-hint">0°</div>
    </div>
  </div>
  <script>
    let currentStream = null;
    let videoElement = null;
    let isStreamReady = false;
    const ROTATION_STEPS = [0, 90, 180, 270];
    const ROTATION_STORAGE_KEY = '${ROTATION_STORAGE_KEY}';
    let rotationDeg = 0;
    let hintTimer = null;

    function loadStoredRotation() {
      try {
        const parsed = Number(localStorage.getItem(ROTATION_STORAGE_KEY));
        if (ROTATION_STEPS.indexOf(parsed) !== -1) return parsed;
      } catch (e) {}
      return 0;
    }

    function persistRotation(deg) {
      try {
        localStorage.setItem(ROTATION_STORAGE_KEY, String(deg));
      } catch (e) {}
    }

    function showHint() {
      const hint = document.getElementById('rotation-hint');
      if (!hint) return;
      hint.textContent = rotationDeg + '°';
      hint.classList.add('show');
      if (hintTimer) clearTimeout(hintTimer);
      hintTimer = setTimeout(function () {
        hint.classList.remove('show');
      }, 900);
    }

    function applyVideoTransform() {
      if (!videoElement) return;
      const player = document.getElementById('local-player');
      let coverScale = 1;
      if ((rotationDeg === 90 || rotationDeg === 270) && player) {
        const w = player.clientWidth || 1;
        const h = player.clientHeight || 1;
        coverScale = Math.max(w / h, h / w);
      }
      videoElement.style.transform =
        'scaleX(-1) rotate(' + rotationDeg + 'deg) scale(' + coverScale + ')';
      videoElement.style.transformOrigin = 'center center';
      videoElement.style.objectFit = 'cover';
    }

    function cycleRotation() {
      const idx = ROTATION_STEPS.indexOf(rotationDeg);
      rotationDeg = ROTATION_STEPS[(idx < 0 ? 0 : idx + 1) % ROTATION_STEPS.length];
      persistRotation(rotationDeg);
      applyVideoTransform();
      showHint();
    }

    function createVideoElement(stream) {
      const container = document.getElementById('local-player');

      if (!videoElement) {
        container.innerHTML = '';
        videoElement = document.createElement('video');
        videoElement.autoplay = true;
        videoElement.playsinline = true;
        videoElement.muted = true;
        videoElement.style.width = '100%';
        videoElement.style.height = '100%';
        videoElement.style.objectFit = 'cover';
        videoElement.style.backgroundColor = '#000';
        container.appendChild(videoElement);
      }

      if (videoElement.srcObject !== stream) {
        videoElement.srcObject = stream;
        videoElement.onloadedmetadata = () => {
          videoElement.play().catch(e => console.error('Play error:', e));
          applyVideoTransform();
        };
      }

      currentStream = stream;
      isStreamReady = true;
      applyVideoTransform();
    }

    function copyVideoStream() {
      if (isStreamReady && currentStream) {
        return;
      }

      try {
        const parentVideo = window.opener && window.opener.document.querySelector('#local-player video');

        if (parentVideo && parentVideo.srcObject) {
          createVideoElement(parentVideo.srcObject);
        } else if (window.opener && window.opener.__videoStream) {
          createVideoElement(window.opener.__videoStream);
        }
      } catch (e) {
        console.error('Error copying video stream:', e);
      }
    }

    window.addEventListener('load', function() {
      rotationDeg = loadStoredRotation();
      const container = document.getElementById('video-container');
      if (container) {
        container.addEventListener('click', cycleRotation);
      }
      window.addEventListener('resize', applyVideoTransform);
      copyVideoStream();
      setInterval(copyVideoStream, 500);
    });
  <\/script>
</body>
</html>`;

export function openVideoWindow(features?: string): Window | null {
  const defaultFeatures =
    'width=800,height=600,menubar=no,toolbar=no,location=no,scrollbars=yes,resizable=yes';
  const videoWindow = window.open(
    '',
    'videoInput',
    features || defaultFeatures
  );

  if (videoWindow) {
    videoWindow.document.write(videoWindowTemplate);
    videoWindow.document.close();
  }

  return videoWindow;
}
